var React = require('react');

function UiPlusThick (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus Thick"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M30,15c0,1.9-1.6,3.5-3.5,3.5h-8v8c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5v-8h-8\n\t\t\t\t\tC1.6,18.5,0,16.9,0,15s1.6-3.5,3.5-3.5h8v-8C11.5,1.6,13.1,0,15,0s3.5,1.6,3.5,3.5v8h8C28.4,11.5,30,13.1,30,15L30,15L30,15z"})))))]);
}

UiPlusThick.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 30 30","style":{"enableBackground":"new 0 0 30 30"},"xmlSpace":"preserve"};

module.exports = UiPlusThick;

UiPlusThick.default = UiPlusThick;
